import React from 'react';

import Card, { CardShadow, CardStyles } from '@app/common/components/cards/Card';
import Icon, { Icons } from '@app/common/components/Icon';
import Button from '@app/common/components/Button';

import styles from './SuggestionCard.module.scss';
import { Spinner, SpinnerTypes } from '@app/common/design-system/spinner';

type SuggestionCardProps = React.PropsWithChildren<{
    handleAdd: () => void | Promise<void>;
    disabled?: boolean;
}>;

const SuggestionCard: React.FC<SuggestionCardProps> = ({ handleAdd, children, disabled }) => {
    const [isLoading, setIsLoading] = React.useState(false);

    const onAdd = async () => {
        const result = handleAdd();
        if (result instanceof Promise) {
            try {
                setIsLoading(true);
                await result;
            } finally {
                setIsLoading(false);
            }
        }
    };
    return (
        <Card className={styles.container} style={CardStyles.SQUARE} shadow={CardShadow.NONE}>
            <Icon icon={Icons.PDF} className={styles.pdfIcon} />
            <div className={styles.children}>{children}</div>
            <div className={styles.actions}>
                {isLoading ? (
                    <Spinner type={SpinnerTypes.SECONDARY} />
                ) : (
                    <Button
                        className={styles.addButton}
                        onClick={onAdd}
                        type="button"
                        disabled={disabled}
                        loading={isLoading}
                    >
                        Add
                    </Button>
                )}
            </div>
        </Card>
    );
};

export default SuggestionCard;
